'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.analytics = undefined;

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _toConsumableArray2 = require('babel-runtime/helpers/toConsumableArray');

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _extends3 = require('babel-runtime/helpers/extends');

var _extends4 = _interopRequireDefault(_extends3);

var _stringify = require('babel-runtime/core-js/json/stringify');

var _stringify2 = _interopRequireDefault(_stringify);

var _analytics; // import { parseFilterToQuery, matchTextToFilter } from 'utils/search';


exports.default = reducer;
exports.clearFilter = clearFilter;
exports.prepFilter = prepFilter;
exports.setFilter = setFilter;
exports.search = search;
exports.openMobileFilter = openMobileFilter;
exports.setPriceRange = setPriceRange;
exports.toggleInstantBooking = toggleInstantBooking;
exports.setDisplayText = setDisplayText;
exports.setOptions = setOptions;
exports.setLastTripId = setLastTripId;
exports.openQuickFilter = openQuickFilter;
exports.setTab = setTab;
exports.setPreActivities = setPreActivities;
exports.setDirty = setDirty;
exports.setSmallColumnHeight = setSmallColumnHeight;
exports.openTourType = openTourType;
exports.openDatePicker = openDatePicker;
exports.logSetFilter = logSetFilter;
exports.logMobileQuickFilter = logMobileQuickFilter;
exports.logMobileApplyFilter = logMobileApplyFilter;
exports.logTourType = logTourType;

var _search = require('utils/search');

var _activities = require('json/activities.json');

var _activities2 = _interopRequireDefault(_activities);

var _destinations = require('json/destinations.json');

var _destinations2 = _interopRequireDefault(_destinations);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CLEAR_FILTER = 'redux-frontend/search/CLEAR_FILTER';
var SET_FILTER = 'redux-frontend/search/SET_FILTER';
var PREP_FILTER = 'redux-frontend/search/PREP_FILTER';

var SET_PRICE_RANGE = 'redux-frontend/search/SET_PRICE_RANGE';

var TOGGLE_INSTANT_BOOKING = 'redux-frontend/search/TOGGLE_INSTANT_BOOKING';

var SEARCH = 'redux-frontend/search/SEARCH';
var SEARCH_SUCCESS = 'redux-frontend/search/SEARCH_SUCCESS';
var SEARCH_FAIL = 'redux-frontend/search/SEARCH_FAIL';

var OPEN_MOBILE_FILTER = 'redux-frontend/search/OPEN_MOBILE_FILTER';
var SET_DISPLAY_TEXT = 'redux-frontend/search/SET_DISPLAY_TEXT';

var SET_OPTIONS = 'redux-frontend/search/SET_OPTIONS';
var SET_TAB = 'redux-frontend/search/SET_TAB';

var SET_LAST_TRIP = 'redux-frontend/search/SET_LAST_TRIP';
var SET_DIRTY = 'redux-frontend/search/SET_DIRTY';

var OPEN_QUICK_FILTER = 'redux-frontend/search/OPEN_QUICK_FILTER';

var LOG_SET_FILTER = 'redux-frontend/search/LOG_SET_FILTER';
var LOG_MOBILE_QUICK_FILTER = 'redux-frontend/search/LOG_MOBILE_QUICK_FILTER';
var LOG_MOBILE_APPLY_FILTER = 'redux-frontend/search/LOG_MOBILE_APPLY_FILTER';

var LOG_TOUR_TYPE = 'redux-frontend/search/LOG_TOUR_TYPE';

var SET_PRE_ACTIVITIES = 'redux-frontend/search/SET_PRE_ACTIVITIES';
var OPEN_TOUR_TYPE = 'redux-frontend/search/OPEN_TOUR_TYPE';
var OPEN_DATE_PICKER = 'redux-frontend/search/OPEN_DATE_PICKER';

var LOAD_COMBINED_STATIC_SUCCESS = 'redux-frontend/info/LOAD_COMBINED_STATIC_SUCCESS';

var SET_SMALL_COLUMN_HEIGHT = 'redux-frontend/search/SET_SMALL_COLUMN_HEIGHT';

var initialstate = {
  filter: {
    text: '',
    raw_keyword: '',
    activities: [],
    languages: ['Any'],
    price_condition: [],
    duration: [],
    other: [],
    sort: 'Recommended',
    starting_time: [],
    instant_booking: '',
    is_include: true,
    is_flexible_date: false,
    is_private_car: false,
    is_hotel_pickup: false,
    price_range: [0, 5000],
    limit: 10,
    skip: 0,
    session_id: null,
    is_instant: false,
    tags: []
  },
  // suggestionText: '',
  loading: false,
  loadingSpinner: false,
  activeInstantBooking: false,
  error: null,
  trips: [],
  first10Trips: [],
  results: 0,
  dirty: false,
  mobileFilter: false,
  priceRange: [0, 5000],
  displayText: '',
  options: { destinations: [], activities: [] },
  lastTripId: null,
  openQuickFilter: false,
  tab: 'advance',
  preActivities: [],
  openTourType: false,
  isOpenDatePicker: false,
  smallColumnHeight: '100%'
};

function reducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialstate;
  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  var newFilter = JSON.parse((0, _stringify2.default)(state.filter)); // improve this
  switch (action.type) {
    case CLEAR_FILTER:
      if (window && window.history && window.history.replaceState) {
        // window.history.replaceState('object or string', 'Title', '/search');
        window.history.replaceState('object or string', 'Title', '/to/Any');
      }
      return (0, _extends4.default)({}, state, {
        filter: (0, _extends4.default)({}, state.filter, {
          activities: [],
          starting_time: [],
          duration: [],
          price_condition: [],
          price_range: [0, 5000],
          is_include: true,
          is_hotel_pickup: false,
          is_private_car: false,
          instant_booking: '',
          location: '',
          date: null,
          is_flexible_date: false,
          // tags: [],
          skip: 0,
          tags: state.filter.tags,
          text: '',
          languages: ['Any'],
          raw_keyword: '',
          is_instant: false,
          sort: 'Recommended'
        }),
        dirty: action.dirty
      });
    case PREP_FILTER:
      // const prepFilters = matchTextToFilter({...newFilter, ...action.filter}, state.options.destinations, state.options.activities);
      var prepFilters = (0, _extends4.default)({}, newFilter, action.filter);
      var prepUrl = (0, _search.parseFilterToQuery)(prepFilters);
      if (window && window.history && window.history.replaceState) {
        window.history.replaceState('object or string', 'Title', prepUrl);
      }
      return (0, _extends4.default)({}, state, {
        filter: prepFilters,
        dirty: action.dirty
      });
    case SEARCH:
      if (window && window.scrollTo && !action.append) {
        window.scrollTo(0, 0);
      }
      return (0, _extends4.default)({}, state, {
        loading: true,
        loadingSpinner: action.append ? false : true,
        loadingMore: action.append
      });
    case SEARCH_SUCCESS:
      return (0, _extends4.default)({}, state, {
        trips: action.append ? [].concat((0, _toConsumableArray3.default)(state.trips), (0, _toConsumableArray3.default)(action.result.trips)) : action.result.trips,
        results: action.result.results,
        loading: false,
        loadingSpinner: false,
        error: false,
        dirty: false,
        loadingMore: false,
        filter: state.filter.text ? state.filter : (0, _extends4.default)({}, state.filter, { raw_keyword: '' }), // clear raw keyword incase of empty text
        // first10Trips: action.append ? state.first10Trips : action.result.tripIds,
        first10Trips: action.filter && action.filter.tripIds && action.filter.tripIds.length > 0 ? state.first10Trips : action.result.tripIds,
        smallColumnHeight: (0, _search.getSmallColumnHeight)()
      });
    case SEARCH_FAIL:
      return (0, _extends4.default)({}, state, {
        loading: false,
        loadingMore: false,
        loadingSpinner: false,
        error: action.result
      });
    case SET_LAST_TRIP:
      return (0, _extends4.default)({}, state, {
        lastTripId: action.id
      });
    case SET_TAB:
      return (0, _extends4.default)({}, state, {
        tab: action.tab
      });
    case SET_DIRTY:
      return (0, _extends4.default)({}, state, {
        dirty: action.dirty
      });
    case OPEN_TOUR_TYPE:
      return (0, _extends4.default)({}, state, {
        openTourType: action.open
      });
    case OPEN_DATE_PICKER:
      return (0, _extends4.default)({}, state, {
        isOpenDatePicker: action.open
      });
    case OPEN_MOBILE_FILTER:
      return (0, _extends4.default)({}, state, {
        mobileFilter: action.open
      });
    case SET_DISPLAY_TEXT:
      return (0, _extends4.default)({}, state, {
        displayText: action.text
      });
    case SET_FILTER:
      newFilter[action.name] = action.value;
      // matchTextToFilter(newFilter, state.options.destinations, state.options.activities);
      var url = (0, _search.parseFilterToQuery)(newFilter);
      if (window && window.history && window.history.replaceState && action.resolvePath) {
        window.history.replaceState('object or string', 'Title', url);
      }
      return (0, _extends4.default)({}, state, {
        filter: newFilter,
        dirty: true
      });
    case SET_PRICE_RANGE:
      return (0, _extends4.default)({}, state, {
        priceRange: action.range
      });
    case SET_OPTIONS:
      return (0, _extends4.default)({}, state, {
        options: (0, _extends4.default)({}, state.options, (0, _defineProperty3.default)({}, action.name, action.value))
      });
    case LOAD_COMBINED_STATIC_SUCCESS:
      var locale = action.locale || 'en';
      return (0, _extends4.default)({}, state, {
        // options: {...state.options, activities: parseActivities(action.result.activities), destinations: parseDestinations(action.result.destinations)}
        options: (0, _extends4.default)({}, state.options, { activities: (0, _search.parseActivities)(_activities2.default[locale]), destinations: (0, _search.parseDestinations)(_destinations2.default[locale]) })
      });
    case TOGGLE_INSTANT_BOOKING:
      return (0, _extends4.default)({}, state, {
        activeInstantBooking: action.active
      });
    case OPEN_QUICK_FILTER:
      return (0, _extends4.default)({}, state, {
        openQuickFilter: action.open
      });
    case SET_PRE_ACTIVITIES:
      var preActivitiesIndex = state.preActivities.indexOf(action.value);
      return (0, _extends4.default)({}, state, {
        preActivities: preActivitiesIndex >= 0 ? [].concat((0, _toConsumableArray3.default)(state.preActivities.slice(0, preActivitiesIndex)), (0, _toConsumableArray3.default)(state.preActivities.slice(preActivitiesIndex + 1))) : [].concat((0, _toConsumableArray3.default)(state.preActivities), [action.value])
      });
    case SET_SMALL_COLUMN_HEIGHT:
      return (0, _extends4.default)({}, state, {
        smallColumnHeight: (0, _search.getSmallColumnHeight)()
      });
    default:
      return state;
  }
}

function clearFilter() {
  var dirty = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

  return {
    type: CLEAR_FILTER,
    dirty: dirty
  };
}

function prepFilter(filter) {
  var dirty = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

  return {
    type: PREP_FILTER,
    filter: filter,
    dirty: dirty
  };
}

function setFilter(name, value) {
  var resolvePath = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

  return {
    type: SET_FILTER,
    name: name,
    value: value,
    resolvePath: resolvePath
  };
}

function search(data) {
  var append = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

  return {
    types: [SEARCH, SEARCH_SUCCESS, SEARCH_FAIL],
    promise: function promise(client) {
      return client.post('/trips/search', { data: data });
    },
    filter: data,
    append: append
  };
}

function openMobileFilter() {
  var open = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
  var source = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'filter';

  return {
    type: OPEN_MOBILE_FILTER,
    open: open,
    source: source
  };
}

function setPriceRange(range) {
  return {
    type: SET_PRICE_RANGE,
    range: range
  };
}

function toggleInstantBooking(active) {
  return {
    type: TOGGLE_INSTANT_BOOKING,
    active: active
  };
}

function setDisplayText(text) {
  return {
    type: SET_DISPLAY_TEXT,
    text: text
  };
}

function setOptions(name, value) {
  return {
    type: SET_OPTIONS,
    name: name,
    value: value
  };
}
function setLastTripId() {
  var id = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

  return {
    type: SET_LAST_TRIP,
    id: id
  };
}

function openQuickFilter() {
  var open = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;

  return {
    type: OPEN_QUICK_FILTER,
    open: open
  };
}

function setTab() {
  var tab = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'advance';

  return {
    type: SET_TAB,
    tab: tab
  };
}

function setPreActivities(value) {
  return {
    type: SET_PRE_ACTIVITIES,
    value: value
  };
}

function setDirty() {
  var dirty = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;

  return {
    type: SET_DIRTY,
    dirty: dirty
  };
}

function setSmallColumnHeight() {
  return {
    type: SET_SMALL_COLUMN_HEIGHT
  };
}

function openTourType() {
  var open = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;

  return {
    type: OPEN_TOUR_TYPE,
    open: open
  };
}
function openDatePicker() {
  var open = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;

  return {
    type: OPEN_DATE_PICKER,
    open: open
  };
}

var analytics = exports.analytics = (_analytics = {}, (0, _defineProperty3.default)(_analytics, LOG_SET_FILTER, function (action, getState) {
  return { name: 'Set Filter', category: 'Search', filterName: action.name, filterValue: action.value, sessionId: getState().search.filter.session_id, openFilter: getState().search.mobileFilter };
}), (0, _defineProperty3.default)(_analytics, LOG_MOBILE_QUICK_FILTER, function (action, getState) {
  return { name: 'Set Mobile Quick Filter', category: 'Search', filterName: action.name, filterValue: action.value, sessionId: getState().search.filter.session_id };
}), (0, _defineProperty3.default)(_analytics, LOG_MOBILE_APPLY_FILTER, function (action, getState) {
  return { name: 'Apply Mobile Filter', category: 'Search', sessionId: getState().search.filter.session_id, filter: getState().search.filter };
}), (0, _defineProperty3.default)(_analytics, LOG_TOUR_TYPE, function (action) {
  return { name: 'Select Tour Type', category: 'Search', tourType: action.value };
}), (0, _defineProperty3.default)(_analytics, OPEN_QUICK_FILTER, function (action, getState) {
  return action.open ? { name: 'Open Mobile Quick Filter', category: 'Search', sessionId: getState().search.filter.session_id } : { name: 'Close Mobile Quick Filter', category: 'Search', sessionId: getState().search.filter.session_id };
}), (0, _defineProperty3.default)(_analytics, OPEN_MOBILE_FILTER, function (action, getState) {
  return action.open ? { name: action.source === 'nav' ? 'Open Mobile Filter From Nav' : 'Open Mobile Filter', category: 'Search', sessionId: getState().search.filter.session_id } : { name: 'Close Mobile Filter', category: 'Search', sessionId: getState().search.filter.session_id };
}), _analytics);

function logSetFilter(name, value) {
  return {
    type: LOG_SET_FILTER,
    name: name,
    value: value
  };
}

function logMobileQuickFilter(name, value) {
  return {
    type: LOG_MOBILE_QUICK_FILTER,
    name: name,
    value: value
  };
}

function logMobileApplyFilter() {
  return {
    type: LOG_MOBILE_APPLY_FILTER
  };
}

function logTourType(value) {
  return {
    type: LOG_TOUR_TYPE,
    value: value
  };
}


//////////////////
// WEBPACK FOOTER
// ./src/redux/modules/search.js
// module id = 80
// module chunks = 47